import I18n from 'i18n-js';
import React from 'react';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import SignupSigninModal from '@reverbdotcom/commons/src/components/signup_signin_modal';
import LocationUtil from '../shared/location_util';
import bind from '@reverbdotcom/commons/src/bind';
import { FOLLOW_PROMPT_PARAM } from '../shared/constants';
import heartEmptyIcon from '@reverbdotcom/cadence/icons/core/heart-empty.svg?component';
import { RCIcon } from '@reverbdotcom/cadence/components/RCIcon/RCIcon';

interface Props extends IUserContext {
  addText?: string;
  modalOpen: boolean;
}

interface State {
  modalOpen: boolean;
}

export class LoggedOutFavoriteButton extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: props.modalOpen,
    };
  }

  @bind
  handleClick(evt) {
    evt.preventDefault();

    this.setState({ modalOpen: true });
  }

  @bind
  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  renderLoginModal() {
    const followPromptParams = { [FOLLOW_PROMPT_PARAM]: true };
    const redirectTo = LocationUtil.currentPageWithParams(followPromptParams);

    return (
      <SignupSigninModal
        onRequestClose={this.handleModalClose}
        active={this.state.modalOpen}
        message={I18n.t('discovery.searchSignup.fullLoginMessage')}
        redirectTo={redirectTo}
        trackSource="FavoriteButton"
      />
    );
  }

  render() {
    return (
      <div className='favorite-button'>
        <button
          type='button'
          className='favorite-button__button'
          onClick={this.handleClick}
        >
          <RCIcon svgComponent={heartEmptyIcon} inline />
          {this.props.addText || I18n.t('discovery.favorites.favoriteButton.addFavorite.search')}
        </button>
        {this.renderLoginModal()}
      </div>
    );
  }
}

export default withUserContext(LoggedOutFavoriteButton);
